
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import AdjustmentForm from './adjustmentForm';
import { createExceptionAdjustmentApi, getUserByPhoneApi } from '../../utils/apisConsts';

class CreateExceptionAdjustment extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Create Advance Adjustment',
                content: <AdjustmentForm isException={true} mostRecent={false} apiName={createExceptionAdjustmentApi}/>,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
} 

export default CreateExceptionAdjustment
